module.exports = __webpack_public_path__ + "img/result.24a6d436.png";